__turbopack_context__.v({
  "editor": "y2G9kq_editor",
  "root": "y2G9kq_root",
});
